


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, Pdi } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import {storeService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveStorePdiPage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};
  public pdiModel: Pdi = {
    laborOpCode: '',
    lineType: 'A',
    serviceLineNumber: 0,
    serviceType: '',
    sequenceNumber: 0,
    transCode: 'IS',
    vehicleType: 0,
  };
  public form: any = {};
  public storePdiFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'Pdi' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.pdiSettings.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.saveStorePdi();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.setPdiFields();
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getStoreInfo();
    }
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }
  public setPdiFields(): void {
    this.storePdiFields = [
      {
        key: 'vehicleType',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.pdiSettings.PdiSettingFields.vehicleType'
          ) as string,
          loading: false,
          items: [
            { key: '0', value: 'New' },
            { key: '1', value: 'Used' },
            { key: '2', value: 'CPO' },
            { key: '3', value: 'Dealertrade' },
          ],
          value: 'key',
          text: 'value',
          altag: 'Vehicle Type',
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Vehicle Type',v)
          ]
        },
      },
      {
        key: 'laborOpCode',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.pdiSettings.PdiSettingFields.laborOpCode'
          ) as string,
          // validations: 'required',
          counter: 9,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v =>  this.required('Labor Op Code',v)
          ]
        },
      },
      {
        key: 'serviceType',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.pdiSettings.PdiSettingFields.serviceType'
          ) as string,
          counter: 2,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [
            v =>  this.required('Service Type',v)
          ]
        },
      },
      {
        key: 'serviceLineNumber',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.pdiSettings.PdiSettingFields.serviceLineNumber'
          ) as string,
          type: 'number',
          counter: 20,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [
            v =>  this.required('Service Line Number',v)
          ]
        },
      },
      {
        key: 'sequenceNumber',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.pdiSettings.PdiSettingFields.sequenceNumber'
          ) as string,
          type: 'number',
          counter: 20,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [
            v =>  this.required('Sequence Number',v)
          ]
        },
      },
      {
        key: 'lineType',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.pdiSettings.PdiSettingFields.lineType'
          ) as string,
          value: 'A',
          counter: 10,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [
            v =>  this.required('Line Type',v)
          ]
        },
      },
      {
        key: 'transCode',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.pdiSettings.PdiSettingFields.transCode'
          ) as string,
          value: 'IS',
          counter: 10,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [
            v =>  this.required('Trans Code',v)
          ]
        },
      },
    ];
  }

  public validateStorePdi(): Vue & { validate: () => boolean } {
    return this.$refs.storePdiForm as Vue & { validate: () => boolean };
  }

  public async saveStorePdi(): Promise<void> {
    if(this.validateStorePdi().validate()){
        var validateRes = this.$validator.errors.items.length > 0;
        if(validateRes){
          this.showAlert(false, 'Please Enter Valid Details');
          return;
        }
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.pdiModel.id === undefined) {
          await storeService.savePdi(this.storeViewModel.id, this.pdiModel);
          if (this.pdiModel.vehicleType === 0) {
            const existing = (
              this.storeViewModel.storeJson.pdiJson.new || []
            ).find((m) => {
              return m.id === this.pdiModel.id;
            });
            if (!existing) {
              this.storeViewModel.storeJson.pdiJson.new.push(this.pdiModel);
            }
          } else if (this.pdiModel.vehicleType === 1) {
            const existing = (
              this.storeViewModel.storeJson.pdiJson.used || []
            ).find((m) => {
              return m.id === this.pdiModel.id;
            });
            if (!existing) {
              this.storeViewModel.storeJson.pdiJson.used.push(this.pdiModel);
            }
          } else if (this.pdiModel.vehicleType === 2) {
            const existing = (
              this.storeViewModel.storeJson.pdiJson.cpo || []
            ).find((m) => {
              return m.id === this.pdiModel.id;
            });
            if (!existing) {
              this.storeViewModel.storeJson.pdiJson.cpo.push(this.pdiModel);
            }
          } else if (this.pdiModel.vehicleType === 3) {
            const existing = (
              this.storeViewModel.storeJson.pdiJson.dealertrade || []
            ).find((m) => {
              return m.id === this.pdiModel.id;
            });
            if (!existing) {
              this.storeViewModel.storeJson.pdiJson.dealertrade.push(
                this.pdiModel
              );
            }
          }
          this.showAlert(
            true,
            this.$t('stores.pdiSettings.alertSavedPdiSetting')
          );
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeId.toString(),
                tab:'Pdi'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {
          await storeService.updatePdi(
            this.storeViewModel.id,
            this.pdiModel
          );
          if (this.pdiModel.vehicleType === 0) {
            const existing = (
              this.storeViewModel.storeJson.pdiJson.new || []
            ).find((m) => {
              return m.id === this.pdiModel.id;
            });
            if (!existing) {
              this.storeViewModel.storeJson.pdiJson.new.push(this.pdiModel);
            }
          } else if (this.pdiModel.vehicleType === 1) {
            const existing = (
              this.storeViewModel.storeJson.pdiJson.used || []
            ).find((m) => {
              return m.id === this.pdiModel.id;
            });
            if (!existing) {
              this.storeViewModel.storeJson.pdiJson.used.push(this.pdiModel);
            }
          } else if (this.pdiModel.vehicleType === 2) {
            const existing = (
              this.storeViewModel.storeJson.pdiJson.cpo || []
            ).find((m) => {
              return m.id === this.pdiModel.id;
            });
            if (!existing) {
              this.storeViewModel.storeJson.pdiJson.cpo.push(this.pdiModel);
            }
          } else if (this.pdiModel.vehicleType === 3) {
            const existing = (
              this.storeViewModel.storeJson.pdiJson.dealertrade || []
            ).find((m) => {
              return m.id === this.pdiModel.id;
            });
            if (!existing) {
              this.storeViewModel.storeJson.pdiJson.dealertrade.push(
                this.pdiModel
              );
            }
          }
          this.showAlert(
            true,
            this.$t('stores.pdiSettings.alertUpdatePdiSetting')
          );
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeId.toString(),
                tab:'Pdi'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storePdiFields);
      const response = await storeService.getStore(this.storeId);
      this.storeViewModel = response;
      this.storeModel.id = this.storeViewModel.id;
      this.storeModel.storeJson = this.storeViewModel.storeJson;
      const pdiTypeId = Number(this.$route.params.pdiTypeId);
      const pdiId = this.$route.params.pdiId;
      if (this.$route.params.pdiId) {
        if (pdiTypeId === 0) {
          this.pdiModel = (
            this.storeViewModel.storeJson.pdiJson.new || []
          ).find((n) => {
            return n.id === pdiId;
          });
        } else if (pdiTypeId === 1) {
          this.pdiModel = (
            this.storeViewModel.storeJson.pdiJson.used || []
          ).find((n) => {
            return n.id === pdiId;
          });
        } else if (pdiTypeId === 2) {
          this.pdiModel = (
            this.storeViewModel.storeJson.pdiJson.cpo || []
          ).find((n) => {
            return n.id === pdiId;
          });
        } else if (pdiTypeId === 3) {
          this.pdiModel = (
            this.storeViewModel.storeJson.pdiJson.dealertrade || []
          ).find((n) => {
            return n.id === pdiId;
          });
        }
        this.pdiModel.vehicleType = pdiTypeId.toString() as any;
        this.storePdiFields.find((n) => {
          return n.key === 'vehicleType';
        }).templateOptions.disabled = true;

        this.setPdiFields();
      }
    } finally {
      this.formlyHideSkeleton(this.storePdiFields);
    }
  }
}
